module.exports = __webpack_public_path__ + "img/check.ba316462.svg";